// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"642":"54f685ca","653":"4ae67cc0"}[chunkId] + ".css";
};